import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contract-policy',
  templateUrl: './contract-policy.component.html',
  styleUrls: ['./contract-policy.component.scss']
})
export class ContractPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
